__turbopack_context__.v({
  "button--activable-default--loading-false": "button-module-scss-module__9D6mlW__button--activable-default--loading-false",
  "button--activable-primary--loading-false": "button-module-scss-module__9D6mlW__button--activable-primary--loading-false",
  "button--activable-secondary--loading-false": "button-module-scss-module__9D6mlW__button--activable-secondary--loading-false",
  "button-auto": "button-module-scss-module__9D6mlW__button-auto",
  "button-default": "button-module-scss-module__9D6mlW__button-default",
  "button-disabled": "button-module-scss-module__9D6mlW__button-disabled",
  "button-giant": "button-module-scss-module__9D6mlW__button-giant",
  "button-large": "button-module-scss-module__9D6mlW__button-large",
  "button-primary": "button-module-scss-module__9D6mlW__button-primary",
  "button-secondary": "button-module-scss-module__9D6mlW__button-secondary",
  "button-small": "button-module-scss-module__9D6mlW__button-small",
  "spinner": "button-module-scss-module__9D6mlW__spinner",
  "spinner-default": "button-module-scss-module__9D6mlW__spinner-default",
  "spinner-disabled": "button-module-scss-module__9D6mlW__spinner-disabled",
  "spinner-primary": "button-module-scss-module__9D6mlW__spinner-primary",
  "spinner-secondary": "button-module-scss-module__9D6mlW__spinner-secondary",
});
